/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from 'react';
import { Avatar, Badge, Box, Grid, Typography } from '@mui/material';
import './Header.css';
import { themes, fonts } from '../../themes/themes';
import AccountModal from '../../Modals/AccountModal/AccountModal';
import UpdatePasswordModalController from '../../Modals/UpdatePasswordModal/UpdatePasswordModalController';
import EmployeeLockScreenController from '../EmployeeLockScreen/EmployeeLockScreenController';
import CBLogo from '../../../assets/images/CB_logo.png';
import { useAppDispatch, useAppSelector } from '../../../infra/hooks';
import { removeAuthToken } from '../../../infra/aggregates/authTokenSlice';
import HeaderNotifController from '../HeaderNotification/HeaderNotifController';
import MenuIcon from '../../../assets/images/menu_icon.svg';
import { setSideBar } from '../../../infra/aggregates/sidebarSlice';
import { commonServices } from '../../../api/services/commonServices';

interface HeaderProps {
  data: any;
  i18n: any;
  changeLang(): any;
  trans: any;
}

const HeaderPresenter = ({ data, i18n, changeLang }: HeaderProps) => {
  const dispatch = useAppDispatch();
  const [isHoverLock, SetIsHoverLock] = useState(false);
  const [isHoverNotify, SetIsHoverNotify] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [isScreenLock, setIsScreenLock] = useState(false);
  const [notificationModal, showNotificationModal] = useState(false);
  const [CDNSignedPAth, setCDNSignedPAth] = useState('');
  const [companyLogo, setCompanyLogo] = useState('');
  const isChangePassword = (val: boolean) => {
    setOpenChangePassword(val);
    setOpenModal(false);
  };
  const sidebar = useAppSelector((state) => state.sidebarSlice.sideBar);

  function changemainLang() {
    changeLang();
  }
  /*   useEffect(() => {}, []); */
  const CDNSignedPAth_S = useAppSelector(
    (state) => state.profilePicSlice.profilePic,
  );
  const selector = useAppSelector((state) => state);
  useEffect(() => {
    const user_id: any = selector.authSlice.user_id;
    const companyID: any = selector.authSlice.company_id;
    const Payload = {
      filepath: CDNSignedPAth_S,
      fullpath: true,
    };
    commonServices.getFilePath(companyID, user_id, Payload).then((res: any) => {
      setCDNSignedPAth(res);
    });
  }, [CDNSignedPAth_S]);

  useEffect(() => {
    const user_id: any = selector.authSlice.user_id;
    const companyID: any = selector.authSlice.company_id;
    const Payload = {
      filepath: data?.company_logo,
      fullpath: true,
    };
    commonServices.getFilePath(companyID, user_id, Payload).then((res: any) => {
      setCompanyLogo(res);
    });
  }, [data?.company_logo]);

  return (
    <Grid container className="main-header" height="5em" marginBottom="1em">
      <Grid
        item
        xs={12}
        className="main-item"
        style={{
          marginTop: '-0.8em',

          height: '5.5em',
        }}
      >
        <Grid container>
          <Grid
            item
            xs={3}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
              <img
                onClick={() => dispatch(setSideBar(!sidebar))}
                src={MenuIcon}
                className="menu_icon"
              />

            <Box
              style={{
                paddingTop: '1.75em',
                paddingLeft: '70px',
                height: 'auto',
              }}
            >
              {selector?.employeeCompanySlice?.logo ? (
                <img
                  src={selector?.employeeCompanySlice?.logo}
                  style={{
                    width: '8em',
                    height: '4em',
                    marginTop: '-0.5em',
                  }}
                />
              ) : (
                <img
                  src={CBLogo}
                  style={{
                    width: '10em',
                    height: '2em',
                  }}
                />
              )}
            </Box>
          </Grid>
          <Grid item xs={5}></Grid>
          <Grid
            item
            xs={4}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'flex-end',
              paddingRight: '1.75em',
            }}
          >
            <Box
              className="icon-box"
              onMouseEnter={() => SetIsHoverLock(true)}
              onMouseLeave={() => SetIsHoverLock(false)}
            >
              <i
                className="las la-unlock-alt icon"
                style={{
                  fontSize: '24px',
                  color: isHoverLock ? themes.blackDefault : themes.defaultIcon,
                }}
                onClick={() => {
                  dispatch(removeAuthToken());
                  setIsScreenLock(true);
                }}
              />{' '}
            </Box>
            <Box
              className="icon-box"
              onMouseEnter={() => SetIsHoverNotify(true)}
              onMouseLeave={() => SetIsHoverNotify(false)}
              onClick={() => {
                showNotificationModal(true);
              }}
            >
              <Badge badgeContent="" color="secondary" variant="dot">
                <i
                  className="las la-bell icon"
                  style={{
                    fontSize: '24px',
                    color: isHoverNotify
                      ? themes.blackDefault
                      : themes.defaultIcon,
                  }}
                ></i>
              </Badge>
            </Box>
            <Box className="lang-box">
              <Typography
                style={{
                  color: themes.primary,
                  fontFamily: fonts.fontFamily,
                  fontWeight: 'bold',
                  fontSize: fonts.title,
                }}
                onClick={() => changemainLang()}
              >
                {i18n.language == 'ar' ? 'En' : 'Ar'}
              </Typography>
            </Box>
            <Box
              style={{
                paddingRight: '1em',
              }}
            >
              <Avatar
                src={CDNSignedPAth}
                style={{
                  width: '2.5em',
                  height: '2.5em',
                  borderRadius: '100px',
                }}
              />{' '}
            </Box>
            <div
              style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                whiteSpace: 'nowrap'
              }}
              onClick={() => setOpenModal(!openModal)}
            >
              <Box
                style={{
                  paddingRight: '1.75em',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    color: themes.blackDefault,
                    fontSize: fonts.title,
                  }}
                >
                  {data?.name}
                </Typography>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    fontSize: fonts.subtitle,
                    color: themes.defaultIcon,
                  }}
                >
                  {data?.designation}
                </Typography>
              </Box>

              <i
                className="las la-caret-down"
                style={{
                  fontSize: '17px',
                  color: themes.greySubtitle,
                  margin: '0 5px',
                }}
              ></i>
            </div>
          </Grid>
        </Grid>
      </Grid>
      {/* Notification Modal */}
      {notificationModal && (
        <HeaderNotifController
          isOpen={notificationModal}
          onCloseModal={() => showNotificationModal(false)}
          // setUnReadCount={UnReadCount}
        />
      )}
      {/* Modals */}
      {openModal && (
        <AccountModal
          isOpen={openModal}
          onCloseModal={() => setOpenModal(false)}
          onOpenChangePassword={isChangePassword}
        />
      )}

      {openChangePassword && (
        <UpdatePasswordModalController
          isModalOpen={openChangePassword}
          closeModal={() => setOpenChangePassword(false)}
        />
      )}

      {/* Lock Screen */}

      {isScreenLock && (
        <div
          style={{
            position: 'absolute',
          }}
        >
          <EmployeeLockScreenController
            isModalOpen={isScreenLock}
            closeModal={() => setIsScreenLock(false)}
          />
        </div>
      )}
    </Grid>
  );
};

export default HeaderPresenter;
